"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchTransaction = exports.fetchTransfers = void 0;
var ExplorerService_1 = require("./ExplorerService");
Object.defineProperty(exports, "fetchTransfers", { enumerable: true, get: function () { return ExplorerService_1.fetchTransfers; } });
Object.defineProperty(exports, "fetchTransaction", { enumerable: true, get: function () { return ExplorerService_1.fetchTransaction; } });
//# sourceMappingURL=index.js.map